/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
 export const data_source = {
    url: '#',
    token: '#',
    prod:true,
    data_prod:true
  };
  